import { Search } from "lucide-react";

const PaymentManagementFilters = () => {
  return (
    <div className="rounded-2xl border border-border/60 bg-card text-card-foreground shadow-sm transition-shadow duration-300 hover:shadow-md">
      <div className="p-4">
        <div className="flex flex-col gap-4 md:flex-row">
          {/* 🔍 Search Input */}
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 pl-10 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
              placeholder="Search by name, PRAN, or Payment ID..."
            />
          </div>

          {/* 🟦 Tabs */}
          <div dir="ltr" data-orientation="horizontal">
            <div
              role="tablist"
              aria-orientation="horizontal"
              className="inline-flex h-10 items-center justify-center rounded-md bg-muted/50 p-1 text-muted-foreground"
            >
              {[
                "All",
                "Completed",
                "Awaiting Approval",
                "Pending",
                "Failed",
              ].map((tab, index) => (
                <button
                  key={tab}
                  type="button"
                  role="tab"
                  className="inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm"
                  data-state={index === 0 ? "active" : "inactive"}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentManagementFilters;
